'use strict'
/**
 * CommonMixin
 * [概要]
 *   MO全体で利用する共通化しておきたい処理をまとめて実装します。
 */

import { appconfig } from '../lib/appconfig.js'
import { langData } from '../lib/lang/index'
import { cloneDeep, set, get } from 'lodash'
import DisplayErrorMixin from '@/mixins/DisplayErrorMixin'

/**
 * ページタイトルを動的に取得する
 * ページ名から言語ファイルに紐づけているページタイトルを返却する。
 * @param {*} pageName ページ名（ルーター定義のname）
 */
function getPageTitle (pageName) {
  if (pageName === 'InputMFCardChargeComplete') {
    pageName = 'InputMFCard'
  }
  return langData[sessionStorage.getItem('lang')]['PageTitle'][pageName]
}

/**
 * 表示用注文明細を生成する
 * 画面に表示するための注文明細（注文内容）を生成してストアに保存します。
 */
function genOrderDetail () {
  this.setDisabledButton(true)

  const _that = this

  // 明細を初期化
  let orderDetail = this.$store.getters.orderDetail

  // storeのデータを参照する
  let receiveStore = this.$store.getters.selectStore
  let cart = this.$store.getters.cart
  let receiveMethod = cart.receive_method

  // 金額計算APIを実行する
  let params = {
    'item_list': [],
    'receive_method': Number(cart.receive_method),
    'accounting_coupon_cd': null
  }
  // 会計割引クーポンを追加
  if (cart.accounting_coupon !== null) {
    params.accounting_coupon_cd = cart.accounting_coupon.coupon_cd
  }
  // item_listを生成
  for (let i = 0; i < cart.item_list.length; i++) {
    let order = cart.item_list[i]
    let item = {
      'setmenu_cd': null,
      'items': [],
      'quantity': order.quantity, // カートの個数を参照する
      'coupon_cd': order.coupon_cd || ''
    }
    if (order.item.item_type === 1) {
      // 単品
      item.setmenu_cd = order.item.category_cd
      item.items.push({ 'item_cd': order.item.category_cd })
    } else {
      // セット
      item.setmenu_cd = order.setmenu.category_cd

      // 単体商品の場合は商品コードをitemsにセットする
      if (order.setmenu_details.length === 0) {
        item.items.push({ 'item_cd': order.setmenu.category_cd })
      } else {
        for (var n = 0; n < order.setmenu_details.length; n++) {
          item.items.push({ 'item_cd': order.setmenu_details[n].item_cd })
        }
      }
    }
    params.item_list.push(item)
  }

  this.callApi('AmountCalculation',
    params
  )
    .then(function (res) {
      if (res.data.result) {
        // 受け取る店舗
        orderDetail.store.name = receiveStore.store_name
        orderDetail.store.imageUrl = receiveStore.image_url

        // 受取方法
        orderDetail.receiveMethod = receiveMethod === '2' ? _that.$i18n.t('ReceiveMethod.InStore') : _that.$i18n.t('ReceiveMethod.Takeout')

        // 明細
        let items = []
        for (var i in cart.item_list) {
          let menu = cart.item_list[i]
          // 商品名を連結する
          let name = _that.jointItemName(menu)

          // 小計
          let price = res.data.value.item_list[i].price

          /** ↓↓↓クーポン利用フラグ */
          // セット割引フラグ
          // 小計値割引禁止フラグを参照して、全てのフラグがtrueであればクーポン割引をしているものとみなす
          let isUseCoupon = false
          // 小計値割引禁止フラグの状態をチェックする
          for (let h = 0; h < menu.setmenu_details.length; h++) {
            isUseCoupon = menu.setmenu_details[h].is_prohibition_discount
            // 小計値割引禁止フラグがfalseの商品が混じっている場合はクーポン使用とはみなさない
            if (!menu.setmenu_details[h].is_prohibition_discount) {
              break
            }
          }
          if (menu.coupon_cd === null) {
            // 小計値割引禁止フラグが立っているがクーポンコードがない商品はクーポンではない
            if (isUseCoupon) {
              isUseCoupon = false
            }
          } else {
            if (menu.setmenu_details.length === 0) {
              isUseCoupon = true
            }
          }
          // 会計割引フラグ
          // 会計割引クーポンが使われているかチェックする
          let isNonTarget = false
          if (isUseCoupon && cart.accounting_coupon !== null) {
            isNonTarget = true
          }
          /** ↑↑↑クーポン利用フラグ */

          items.push({
            name,
            quantity: menu.quantity,
            price,
            taxType: _that.getTaxDisplay(res.data.value.tax_type),
            isUseCoupon,
            isNonTarget
          })
        }
        orderDetail.items = items

        // 会計割引クーポン
        orderDetail.accountingCoupon = {
          isUse: false,
          couponCd: null,
          title: null,
          discountPrice: 0,
          taxType: null,
          isApplying: true // クーポン適用不可フラグ
        }
        if (res.data.value.accounting_coupon !== null && res.data.value.accounting_coupon !== undefined) {
          orderDetail.accountingCoupon = _that.displayAccountingCoupon(res.data.value.accounting_coupon.discount_price, _that.getTaxDisplay(res.data.value.tax_type))
        }

        // ポイント割引可能金額
        orderDetail.discountablePrice = res.data.value.discountable_price

        // 合計
        orderDetail.totalPrice = res.data.value.total_price
        orderDetail.taxType = _that.getTaxDisplay(res.data.value.tax_type)

        // 明細をstoreに格納する
        _that.$store.dispatch('setOrderDetail', orderDetail)
      } else {
        DisplayErrorMixin.methods.errorFromApi(res.data.errorCode, res.data.error)
      }
    })
    .catch((error) => {
      DisplayErrorMixin.methods.errorFromAxios(error)
    })
    .finally(() => {
      _that.setDisabledButton(false)
    })
}

/**
 * APIのURLを生成する
 * keyに紐づくAPIのURLを生成して返却します。
 * 存在しないkeyの場合はnullを返却します。
 * @param {*} key APIのキー名
 */
function getApiUrl (key) {
  // path[key]が存在しない場合はnullを返却する
  if (appconfig.apiSetting.path[key] === undefined) {
    return null
  }

  // キャッシュ対策（クエリに端末時間を付与する）
  let query = `?t=${Date.now()}`

  return appconfig.apiSetting.baseUrl
    .concat('/mo/api/')
    .concat(appconfig.version)
    .concat(appconfig.apiSetting.path[key])
    .concat(query)
}

/**
 * ログイン情報取得
 * sessionStorageに保存済みのログイン情報を取得して返却します。
 */
function getLoginInfo () {
  let isLogin = false
  let data = null
  try {
    if (sessionStorage.getItem('login') !== null &&
      sessionStorage.getItem('login') !== undefined) {
      isLogin = true
      data = JSON.parse(sessionStorage.getItem('login'))
    }
  } catch (ex) {
    // loginにJSON以外が入れられていた場合、loginをリセットする
    isLogin = false
    sessionStorage.removeItem('login')
  }
  return {
    isLogin,
    data
  }
}

/**
 * APIにリクエストする時に必要なヘッダの設定を返却する
 * APIリクエストに必要なヘッダを取得します。
 * また、タイムアウトをミリ秒で設定して、画面に返却します。
 */
function getAjaxRequestHeaders () {
  return {
    headers: appconfig.apiSetting.requestHeaders,
    timeout: 60000
  }
}

/**
 * ホームページの名前を返却する
 * ホームページの名前（ルーター定義のname）を返却します。
 */
function getHomepage () {
  return appconfig.homepage
}

/**
 * 受取方法の表示文字列を返却する
 * 受け取り方法選択画面で選択した受け取り方法に応じて、注文明細などに表示する受け取り方法のテキストを返却します。
 */
function getTextReceiveMethod () {
  if (this.$store.getters.cart.receive_method === '1') {
    return this.$i18n.t('ReceiveMethod.Takeout')
  } else if (this.$store.getters.cart.receive_method === '2') {
    return this.$i18n.t('ReceiveMethod.InStore')
  }
  return null
}

/**
 * title要素に出力する文字列を生成する
 * pageName（言語設定に応じた文字列）を、ヘッダーに出力する定型文言と連結して返却します。
 * @param {*} pageName ページ名（言語ごとの文字列）
 */
function getTitleElementString (pageName) {
  return `${pageName} | First Kitchen`
}

/**
 * 画像パスをコンポーネント取り込む
 * 画像のURIを返却します。
 * 通常、http/httpsから始まる場合は無加工で返却します。
 * @param {*} uri 画像のURI
 */
function importImageUri (uri) {
  // uriに何もなければ空文字を返す
  if (uri === null || uri === undefined || uri.length === 0) {
    return ''
  }

  if (appconfig.appMode === 'develop' && !uri.match('^(http|https)://')) {
    // 開発時かつフルパスでない場合ははassets内画像をrequireして返却する
    return require('../' + uri)
  }

  return uri
}

/**
 * 税区分表示
 * typeに応じて税区分を言語に応じた文字列で返却します。
 * @param {*} type 税区分
 */
function getTaxDisplay (type) {
  switch (Number(type)) {
    case 1:
      return `（${this.$i18n.t('General.Tax.Exclude')}）`
    case 2:
      return `（${this.$i18n.t('General.Tax.Include')}）`
    default:
      // 税区分が渡されていない時の初期表示（税込を初期値として設定）
      return `（${this.$i18n.t('General.Tax.Include')}）`
  }
}

/**
 * 電話のURLスキームを生成する
 * 電話番号にtelスキームを連結して返却します。
 * @param {*} tel 電話番号（ハイフンの有無を問わず）
 */
function getTelUrlScheme (tel) {
  return `tel:${tel.replace(/-/g, '')}`
}

/**
 * 国際ブランドを判別する
 * クレジットカードの国際ブランドを判別して、ブランド名称を返却します。
 * MOで対応する国際ブランド→VISA、JCB、MasterCard
 * @param {*} type 国際ブランド種別
 */
function getInternationalBrand (type) {
  // typeが2文字以上の場合はそのまま返却する
  if (type !== null && type !== undefined && type.length > 0) {
    if (type.length > 1) {
      return type
    }
    // typeの文字列から判定する
    switch (type.toLowerCase()) {
      case 'v':
        return 'VISA'
      case 'm':
        return 'Mastercard'
      case 'j':
        return 'JCB'
      case 'a':
        return 'AmericanExpress'
      case 'd':
        return 'Diners'
      default:
        break
    }
  }
  return 'Other'
}

/**
 * SBPS設定を取得する
 * Softbank Payment Serviceを利用する時の設定を、appconfig.jsから取得して返却します。
 * 返却する設定は、appModeに応じたものを返却するものとします。
 */
function getSbpsSetting () {
  return appconfig.sbpsSetting[appconfig.appMode] || null
}

/**
 * オンラインチャージサイトURLを取得する
 * マイファーストカードのオンラインチャージサイトのURLをappconfigから取得して返却します。
 */
function getOnlineChargeUrl () {
  return appconfig.MFOnlinChageUrl
}

/**
 * カート情報をクリアする
 * カートの情報をクリアして初期化します。
 * clearall===trueの場合、選択カテゴリ、選択商品も初期化します。
 * @param {*} clearall 選択カテゴリ、選択商品をクリアするかを選択
 */
function clearCart (clearall) {
  // null,undefinedなどbooleanでなければ初期値をfalseとする
  if (typeof clearall !== 'boolean') {
    clearall = false
  }
  // カートをクリアする
  this.$store.dispatch('setCart', {
    receive_method: null,
    item_list: [],
    accounting_coupon: null,
    menu_category_type: null
  })
  // 選択カテゴリ、選択商品をクリアする
  if (clearall) {
    this.$store.dispatch('setSelectCategory', {
      category_cd: null,
      category_name: null,
      image_url: null
    })
    this.$store.dispatch('setSelectItem', {
      item: null,
      setmenu: null,
      setmenu_details: [],
      coupon_cd: null,
      quantity: 1
    })
  }
}

/**
 * 注文明細をクリアする
 * 注文明細をクリアして、初期化します。
 */
function clearOrderDetail () {
  this.$store.dispatch('setOrderDetail', {
    orderId: null,
    ticketNumber: null,
    receiveMethod: null,
    store: {
      name: null,
      imageUrl: null
    },
    items: [],
    accountingCoupon: {
      isUse: false,
      couponCd: null,
      title: null,
      discountPrice: 0
    },
    receive_method: 0,
    totalPrice: null,
    taxType: null,
    tableNumber: null
  })
}

/**
 * ドメイン設定を取得する
 * ビルド毎にnode.envに設定した、ドメインURLを返却します。
 */
function getDomainUrl () {
  return process.env.VUE_APP_DOMAIN_URL
}

/**
 * 連打防止フラグ
 * 連打防止のためのフラグを操作します。
 * @param {*} disabled フラグ
 */
function setDisabledButton (disabled) {
  this.$store.dispatch('setDisabledButton', disabled)
}

/**
 * 桁区切り表示
 * 引数numに桁区切りのカンマを挿入して返却します。
 * @param {*} num
 */
function displayThousandsSeparator (num) {
  if (num === null || num === undefined) {
    return ''
  }
  return String(num).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
}

/**
 * ポーリング間隔をappconfigから取得する
 * appconfigからポーリングする際の間隔時間を取得します。
 * appconfigには秒で設定するため、返却前にミリ秒に変換します。
 */
function getPorllingInterval () {
  return appconfig.porllingInterval * 1000 // 1000分の1秒に変換して返却する
}

/**
 * viewportの設定内容を取得する
 * viewportに設定する内容を返却します。
 * @param {*} mode [ reset, default ]
 */
function restoreScaleRate (mode) {
  const viewport = {
    default: 'width=device-width,initial-scale=1.0',
    reset: 'width=device-width,initial-scale=1.0,minimum-scale=1.0,maximum-scale=1.0'
  }
  if (mode === 'reset') {
    document.querySelector('meta[name=viewport]').setAttribute('content', viewport.reset)
  } else {
    document.querySelector('meta[name=viewport]').setAttribute('content', viewport.default)
  }
}

/**
 * ブランド名を取得
 * typeに応じて、First Kitchenの企業ブランド名を返却します。
 * 無関係な値が渡された場合は空値を返却します。
 * @param {*} type 1=FirstKitchen, 2=Wendy's
 */
function getBrandName (type) {
  switch (type) {
    case 1:
      return this.getCompanyName('FK')
    case 2:
      return this.getCompanyName('WFK')
    default:
      return ''
  }
}

/**
 * 企業名を返却する
 * appconfigに設定した企業（ブランド）名を返却します。
 * @param {*} company [ FK, WFK ]
 */
function getCompanyName (company) {
  return appconfig.companyName[company.toUpperCase()]
}

/**
 * プライバシーポリシーのURLを返却する
 * appconfigに設定した、プライバシーポリシーのページのURLを返却します。
 */
function getPrivacyPolicyUrl () {
  return appconfig.privacyPolicyUrl
}

/**
 * 営業時間判定
 * 現在時間と店舗の営業時間を比較して、開店中かどうかを判定してStoreに結果をセットします。
 * @param {*} timer タイマーオブジェクト
 * @param {*} selectStore 選択している店舗のオブジェクト
 */
function setIsSales (timer, selectStore) {
  // タイマー時間をパース
  let year = timer['datetime'].getFullYear().valueOf()
  let month = timer['datetime'].getMonth().valueOf()
  let date = timer['datetime'].getDate().valueOf()
  // 店舗の営業時間
  let open = new Date(year, month, date,
    selectStore.opening_time.substring(0, 2),
    selectStore.opening_time.substring(3, 5),
    0)
  let close = new Date(year, month, date,
    selectStore.closing_time.substring(0, 2),
    selectStore.closing_time.substring(3, 5),
    0)
  // 深夜営業の店舗の場合閉店時間を+1dayして調整する
  if (close < open) {
    close = new Date(year, month, date + 1,
      selectStore.closing_time.substring(0, 2),
      selectStore.closing_time.substring(3, 5),
      0)
  }

  if (timer['datetime'] >= open && timer['datetime'] < close) {
    this.$store.dispatch('setIsOpen', true)
  } else {
    this.$store.dispatch('setIsOpen', false)
  }
}

/**
 * メニュー時間帯判定
 * 現在時間と店舗の営業時間を比較して、モーニングorグランドが受付中であるかどうかを判定してストアにセットします。
 * @param {*} timer タイマーオブジェクト
 * @param {*} selectStore 選択している店舗のオブジェクト
 */
function setIsAcceptingMenu (timer, selectStore) {
  let ret = {
    morning: false,
    grand: false
  }

  // グランド時間を参照する
  let grandTime = {
    start: selectStore.grand_start_time.replace(':', ''),
    end: selectStore.lastorder_time.replace(':', '')
  }
  let now = timer['datetime'].getHours().toString()
  now += timer['datetime'].getMinutes() < 10 ? 0 + timer['datetime'].getMinutes().toString() : timer['datetime'].getMinutes().toString()

  if (selectStore.has_morning_menu) {
    // モーニング時間を参照する
    let morningTime = {
      start: selectStore.morning_start_time.replace(':', ''),
      end: selectStore.morning_end_time.replace(':', '')
    }

    // 現在時刻がモーニング時間帯であるならモーニング時間と判定
    if (Number(now) >= Number(morningTime.start) && Number(now) < Number(morningTime.end)) {
      ret.morning = true
    } else if (Number(now) >= Number(grandTime.start) && Number(now) < Number(grandTime.end)) {
      ret.grand = true
    }
  } else {
    // モーニングメニューを実施してない店舗の場合
    if (Number(now) >= Number(grandTime.start) && Number(now) < Number(grandTime.end)) {
      ret.grand = true
    }
  }

  this.$store.dispatch('setIsAcceptingMenu', ret)
}

/**
 * 商品名を連結する
 * セット商品の商品名を連結して返却します。
 * @param {*} menu 商品のオブジェクト
 */
function jointItemName (menu) {
  let name
  try {
    name = menu.item.category_name
    for (let n in menu.setmenu_details) {
      if (!menu.setmenu_details[n].is_main_menu) {
        name += '<br>'
        name += menu.setmenu_details[n].item_name
      }
    }
    // 「セット」を最後に連結する
    if (menu.item.item_type === 2 || menu.setmenu.item_type === 2) {
      name += ` ${this.$i18n.t('General.Set')}`
    }
  } catch (ex) {
    name = null
    DisplayErrorMixin.methods.errorFromApp(ex)
  }
  return name
}

/**
 * 会計割引クーポンの表示制御
 * 会計割引クーポンの登録状態を確認します。登録されている場合は、画面に表示する情報を生成して返却します。
 * @param {*} discountPrice 値引き額
 * @param {*} taxType 税区分
 */
function displayAccountingCoupon (discountPrice, taxType) {
  // 初期化
  let model = {
    isUse: false,
    couponCd: null,
    title: null,
    discountPrice: 0,
    taxType: null,
    isApplying: true // クーポン適用不可フラグ
  }
  // カートを取得
  const cart = this.$store.getters.cart
  // 会計割引クーポンが追加されていたら表示を更新
  if (cart.accounting_coupon !== null) {
    model = {
      isUse: true,
      couponCd: cart.accounting_coupon.coupon_cd,
      title: cart.accounting_coupon.title,
      discountPrice,
      taxType,
      isApplying: true
    }
    if (model.discountPrice === 0) {
      model.isApplying = false
    }
  }
  return model
}

/**
 * メニューカテゴリー種別を設定する
 * メニュー時間帯に対応するメニューカテゴリー種別を設定します。
 */
function setMenuCategoryType () {
  const cart = this.$store.getters.cart
  const acceptingMenu = this.$store.getters.isAcceptingMenu
  if (acceptingMenu.morning) {
    cart.menu_category_type = 1
  } else if (acceptingMenu.grand) {
    cart.menu_category_type = 2
  } else {
    cart.menu_category_type = null
  }
  this.$store.dispatch('setCart', cart)
}

/**
 * 背景スクロールを防止する
 * モーダルを開いている時は、body要素のDoMのスタイルを変更して背景のスクロールを防止します。
 * @param {*} doPrevent 防止フラグ
 */
function preventBackgroundScrolling (doPrevent) {
  if (doPrevent) {
    document.getElementsByTagName('body')[0].style.overflow = 'hidden'
  } else {
    document.getElementsByTagName('body')[0].style.overflow = 'visible'
  }
}

/**
 * APIコール
 * バックエンドAPIの呼び出し処理のラッパー
 * 特権ユーザの未来日アクセス用パラメータを追加します
 */
function callApi (identifier, _params) {
  const params = cloneDeep(_params)
  if (this.$store.getters.openAt !== null) {
    set(params, 'open_at', this.$store.getters.openAt)
  }
  return this.axios.post(
    this.getApiUrl(identifier),
    params,
    this.getAjaxRequestHeaders()
  )
}

/**
 * 店舗変更チェック＆カートを空にする処理
 * storeCode = 新しく選択した店舗コード
 * 現在選択中の店舗コードと一致しなければカートと注文明細をクリアする
 */
function checkStoreCode (storeCode) {
  if (get(this.getSelectStore, 'store_cd', null) !== storeCode) {
    this.clearCart(false)
    this.clearOrderDetail()
  }
}

/**
 * セッションストレージにエラーコードをセットし、エラーページへ遷移する
 */
function moveToError (errorCode) {
  sessionStorage.setItem('errorCode', errorCode)
  this.$router.push({ name: 'ErrorPage' })
}

/**
 * セッションストレージからエラーコードを取得し、セッションストレージをクリアする
 */
function getErrorCode (errorCode) {
  const errcode = sessionStorage.getItem('errorCode')
  sessionStorage.removeItem('errorCode')
  return errcode
}

export default {
  data () {
    return {
    }
  },
  methods: {
    getPageTitle,
    genOrderDetail,
    getApiUrl,
    getAjaxRequestHeaders,
    getHomepage,
    getTextReceiveMethod,
    getTitleElementString,
    importImageUri,
    getTaxDisplay,
    getTelUrlScheme,
    getInternationalBrand,
    getLoginInfo,
    getSbpsSetting,
    getOnlineChargeUrl,
    clearCart,
    clearOrderDetail,
    getDomainUrl,
    setDisabledButton,
    displayThousandsSeparator,
    getPorllingInterval,
    restoreScaleRate,
    getBrandName,
    getCompanyName,
    getPrivacyPolicyUrl,
    setIsSales,
    setIsAcceptingMenu,
    jointItemName,
    displayAccountingCoupon,
    setMenuCategoryType,
    preventBackgroundScrolling,
    callApi,
    checkStoreCode,
    moveToError,
    getErrorCode
  }
}



// WEBPACK FOOTER //
// ./src/mixins/CommonMixin.js